import { makeStyles } from '@material-ui/styles'
import { isAdmin } from 'app/plugins/infrastructure/components/common/helpers'
import Badge from 'core/elements/badge'
import Button from 'core/elements/button/Button'
import IconButton from 'core/elements/button/IconButton'
import colors from 'core/themes/base/colors'
import Theme from 'core/themes/model'
import { routeManager } from 'core/utils/routes'
import EllipsisText from 'k8s/components/common/EllipsisText'
import React from 'react'
import useReactRouter from 'use-react-router'
import { IAppsDetailsPageTabs } from '../../model'
import CreateNewAppModal from '../app/CreateNewAppModal'
import { defaultAppIconPath } from '../constant'
import { appStatus, getResourceDetails, useBreakpointMatch } from '../helper'
import InfoBox from '../InfoBox'
import RowInfo from '../RowInfo'

const TemplateCardView = ({
  iconName,
  headerName,
  subHeaderName,
  vms,
  status,
  version,
  ownerName,
  handleClick,
  data,
}) => {
  const classes = useStyles()
  const { history } = useReactRouter()
  const isBelowCustom = useBreakpointMatch(1600)

  const resourceDetails = getResourceDetails(data)

  const templateDetails = [
    {
      label: 'Owner',
      value: ownerName,
      imagePath: '',
      showDivider: false,
    },
  ]
  const redirectToCreateVolume = (selectedTemplateId) => {
    history.replace(
      `${routeManager.routes.openstack.createApps.path({
        tab: IAppsDetailsPageTabs.Allapps,
      })}?selectedTemplateId=${selectedTemplateId}`,
    )
  }
  const onButtonClick = () => {
    redirectToCreateVolume(data?.uid)
  }

  return (
    <>
      <CreateNewAppModal
        addRoute={routeManager.routes.openstack.createApps}
        tabName={IAppsDetailsPageTabs.Allapps}
        data={data}
      />
      <div className={classes.cardContainer}>
        <div className={classes.headerContainer}>
          <div className={classes.iconsContainer}>
            <div>
              <img src={iconName || defaultAppIconPath} className={classes.iconWrapper} />
            </div>

            <div className={classes.headerText}>
              <EllipsisText
                title={headerName}
                showTooltip={true}
                maxWidth={isBelowCustom ? 220 : undefined}
                variant="subtitle2"
              >
                {headerName}
              </EllipsisText>
              <EllipsisText
                title={subHeaderName}
                showTooltip={true}
                maxWidth={isBelowCustom ? 220 : undefined}
                variant="body2"
              >
                {subHeaderName}
              </EllipsisText>
            </div>
          </div>
          {isAdmin() && (
            <IconButton
              size="md"
              icon="ellipsis-vertical"
              solid={true}
              className={classes.settingsMenuButton}
              onClick={handleClick}
            />
          )}
        </div>
        <div className={classes.statusContainer}>
          <Badge className={classes.badge} variant={appStatus.Default} text={`${vms} VMs`} />
          <Badge className={classes.badge} variant={appStatus.Default} text={version} />
        </div>
        <div className={classes.subTextContainer}>
          {resourceDetails?.map((item, index) => (
            <InfoBox
              label={item?.label}
              value={item?.value}
              imagePath={item?.imagePath}
              showDivider={item?.showDivider}
            />
          ))}
        </div>
        <div className={classes.bodyText}>
          {templateDetails?.map((item) => (
            <RowInfo label={item?.label} value={item?.value} minWidth={60} />
          ))}
        </div>
        <div>
          <Button
            variant="secondary"
            icon="plus"
            // disabled={params.terraformModulePath !== '' && params.tag !== ''}
            onClick={onButtonClick}
            className={classes.customButton}
          >
            Create APP
          </Button>
        </div>
      </div>
    </>
  )
}
export default TemplateCardView

const useStyles = makeStyles<Theme>((theme) => ({
  headerText: {
    display: 'grid',
    gap: theme.spacing(0.5),
    minWidth: 0,
    flexGrow: 1,
  },
  cardContainer: {
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: 4,
    padding: theme.spacing(3),
    background: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  subContainer: {
    display: 'grid',
    gap: theme.spacing(1),
    margin: theme.spacing(3, 0, 3, 0),
  },
  subTextContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  subText: {
    minWidth: 65,
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.palette.grey[200]}`,
    width: theme.spacing(4),
    height: theme.spacing(4),
    rotate: '90deg',
    '& i': {
      color: theme.palette.grey[500],
    },
    cursor: 'pointer',
  },
  iconsContainer: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
  },
  iconWrapper: {
    width: 56,
    height: 56,
  },
  bodyText: {
    display: 'grid',
    gap: theme.spacing(1),
    minWidth: 0,
    flexGrow: 1,
  },
  statusContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  settingsMenuButton: {
    '&:hover': {
      backgroundColor: colors.grey[200],
    },
  },
  badge: {
    backgroundColor: '#FAFAFC',
    borderColor: '1px solid #E6E6EA',
  },

  customButton: {
    minWidth: '100%',
    '& .button-text': {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      gap: theme.spacing(1),
    },
  },
}))
